import BaseAppService from "../../../application/platform/base-app-service";
import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useManagedUnitDispatch, } from "./managed-unit-context";
import { IListQuestionAnwserRequest } from "../../../model/base/request/list-question-anwser-request";

export const useManagedUnitController = () => {
    const ManagedUnitDispatch = useManagedUnitDispatch();
    async function loadData() {
        try {
            const result = await PortalAppService.listManagementUnit();
            ManagedUnitDispatch({
                type: ACTION_TYPES.loadingData,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData
    };
}


